export default "__VITE_ASSET__XCP$RRl9__"